import { LocaleRouteMatcher } from "./locale-route-matcher";
import { RouteMatcher } from "./route-matcher";
export class PagesRouteMatcher extends RouteMatcher {
}
export class PagesLocaleRouteMatcher extends LocaleRouteMatcher {
}

//# sourceMappingURL=pages-route-matcher.js.map